import { DEFAULT_MAX_CONSUMTION_ALLOWED } from 'utils/constants'

export const getConsumptionByEnergy = (energies, selectedProduct) => {
  const maxConsumptionAllowed =
    energies?.find(({ type }) => type === selectedProduct.energyType)?.maxConsumptionAllowed || DEFAULT_MAX_CONSUMTION_ALLOWED
  return maxConsumptionAllowed
}
